import React, { Component } from "react";
import { Table, Button, Modal, Col, Row, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import CondicionalForm from '../components/CondicionalForm';
import CondicionaisPrintModal from "../relatorios/CondicionaisPrintModal";
import CondicionalPrintModal from "../relatorios/CondicionalPrintModal";
import PedidoFiltroForm from '../components/PedidoFiltroForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao, removeToken } from "../utils/LoginManager";
import Colors from '../utils/Colors';
import TutorialCondicionais from '../tutoriais/LancCondicionais';

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    totalVendas: 0,
    qtdeVendas: 0,
    formFiltroVisivel: false,
    formPrintA4Visivel: false,
    idfCond: 0,

    filtros: {
      tipoTela: 'CON',
      buscaOrdem: { campo: 'venc_dt_venda', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaPessoa: { key: '0', },
      buscaProduto: { key: '0', },
      buscaGrupoProduto: { key: '0', },
      buscaMarcaProduto: { key: '0', },
      buscaServico: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaSitFin: { key: 'X', },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, totalVendas: 0, qtdeVendas: 0 });
    const { pagina, limite } = this.state;
    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaSitFin, buscaOrdem } = this.state.filtros;

    let dataIni = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dataFim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/condicional', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          pessoa: buscaPessoa.key,
          usuario: buscaUsuario.key,
          sitFin: String(buscaSitFin.key),
          dataIni,
          dataFim,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.dados;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          totalVendas: response.data.totalVendas,
          qtdeVendas: response.data.qtdeVendas,
        });
      })
      .catch(error => {
        console.warn(error);
        this.setState({ carregando: false });
        if (error.response.status === 504) {
          Modal.warning({ title: 'Sessão Finalizada!', content: error.response.data, });
          removeToken();
        }
      });
  };



  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.venc_idf) {
      request = axios.put(`/condicional/update/${registro.venc_idf}`, registro);
    } else {
      request = axios.post(`/condicional/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Pedido gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
        } else if (error.response.status === 504) {
          Modal.warning({ title: 'Sessão Finalizada!', content: error.response.data, });
          removeToken();
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }

      })
  }

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      visualizar: false,
      registroSelecionado: {
        dados: {
          venc_idf: 0,
          venc_numero: '',
          venc_dt_venda: moment().format('DD/MM/YYYY'),
          venc_obs: '',
          venc_qtde_itens: 0,
          venc_vlr_itens: 0,
          venc_vlr_acres: 0,
          venc_vlr_desc: 0,
          venc_vlr_total: 0,
          venc_pessoa: { key: '0' },
          venc_usuario: { key: '0' },
          venc_tipo_doc: { key: '0' },
          venc_cond_pagto: { key: '0' },
          listaProdutos: [],
          visualizando: false,
        }
      },
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/condicional/show/${registro.venc_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.venc_pessoa = {
          key: String(data.dados.venc_pessoa),
          label: data.dados.usu_nome,
        }
        data.dados.venc_usuario = {
          key: String(data.dados.venc_usuario),
          label: data.dados.usu_nome,
        }
        data.dados.venc_dt_venda = moment(data.dados.venc_dt_venda, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.visualizar = visualizar;

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
        if (error.response.status === 504) {
          Modal.warning({ title: 'Sessão Finalizada!', content: error.response.data, });
          removeToken();
        }
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/condicional/delete/${registro.venc_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.venc_idf === registro.venc_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            if (error.response.status === 412) {
              Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', })
            } else if (error.response.status === 504) {
              Modal.warning({ title: 'Sessão Finalizada!', content: error.response.data, });
              removeToken();
            } else {
              Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
            }
          })
      }
    })
  };

  onImprimirA4Click = (venc_idf) => {
    this.setState({
      idfCond: venc_idf,
      formPrintA4Visivel: true,
    });
  };

  onCancelarPrintClick = () => {
    this.setState({
      idfCond: 0,
      formPrintA4Visivel: false,
      formPrintCupomVisivel: false
    })
  }


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    this.setState({
      [id]: value
    });
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaControle: String(this.state.filtros.buscaControle),
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaMarcaProduto: this.state.filtros.buscaMarcaProduto,
        buscaServico: this.state.filtros.buscaServico,
        buscaSitFin: this.state.filtros.buscaSitFin,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };




  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('CondicionaisPage', 'editar') ? (
          <span>
            {
              registro.qtdeItens === registro.qtdeOK ? (
                <span>
                  <Tooltip title="Visualizar">
                    <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
                  </Tooltip>
                </span>
              ) : (
                <span>
                  <Tooltip title="Editar">
                    <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
                  </Tooltip>
                </span>
              )
            }
          </span>
        ) : (
          <span>
            <Tooltip title="Visualizar">
              <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
            </Tooltip>
          </span>
        )}
        {getTemPermissao('CondicionaisPage', 'excluir') ? (
          <span>
            <Tooltip title="Excluir">
              <Button type="danger" size="small" disabled={registro.qtdeItens === registro.qtdeOK} onClick={() => this.onExcluirClick(registro)} icon="delete" />
            </Tooltip>
          </span>
        ) : null}
        <span>
          <Tooltip title="Impressão">
            <Button type="ghost" size="small" onClick={() => this.onImprimirA4Click(registro.venc_idf)} icon="printer" />
          </Tooltip>
        </span>
      </ButtonGroup>
    );
  };

  renderValor = (venc_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(venc_vlr_total)).format('0,000.00')} </span>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      filtros, formFiltroVisivel, formPrintA4Visivel, total, pagina, limite } = this.state;

    // console.log('CondicionaisPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="tituloPage">Gerenciar Condicionais</span>
          <Tooltip title="Ajuda">
            <Button
              type="primary"
              onClick={() => this.setState({ modalOpen: true })}
              icon="question"
              style={{ fontSize: 20, marginTop: 8, backgroundColor: Colors.primaryLight, borderColor: Colors.primaryLight }}
            ></Button>
          </Tooltip>
        </div>
        <div className="divider-page1" />

        <div className="pageFiltro" style={{ height: 50 }}>
          <Col xs={24} >
            <Col xs={10}>
              {getTemPermissao('CondicionaisPage', 'novo') ? (
                <Col xs={2} style={{ width: 110 }}>
                  <Button
                    type="primary"
                    onClick={this.onAdicionarClick}
                    className="botao-primary"
                  >
                    Adicionar
                  </Button>
                </Col>
              ) : null}

              <Col xs={2} style={{ width: 110 }}>
                <Button
                  type="primary"
                  onClick={this.onAbrirFiltroClick}
                  className="botao-primary"
                  style={{ marginRight: 15 }}
                >
                  Filtrar
                </Button>
              </Col>

              <Col xs={2} style={{ width: 110 }}>
                <CondicionaisPrintModal
                  filtros={filtros}
                  totalVendas={this.state.totalVendas}
                  qtdeVendas={this.state.qtdeVendas}
                />
              </Col>

              <PedidoFiltroForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />
            </Col>

            <Col xs={24} md={8} style={{ height: 65, padding: 5, marginTop: -25 }}>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Qtde Vendas
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.state.qtdeVendas}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
              <Col xs={24} md={12} style={{ height: 65, padding: 5 }}>
                <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: "white" }}>
                  <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                    <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                      Valor Total
                    </span>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Row style={{ marginTop: -5 }}>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.totalVendas)}</span>
                    </Row>
                  </Row>
                </div>
              </Col>
            </Col>

            {/* <Col xs={24} sm={11} style={{ background: Colors.background, padding: 5, marginTop: -10 }}>
              <Col xs={24} sm={11} style={{ marginRight: 5, textAlign: "center", background: "white", marginLeft: 5 }} >
                <Row><span style={{ fontWeight: "bold" }}>Qtde Vendas</span></Row>
                <Row><span>{this.state.qtdeVendas}</span></Row>
              </Col>
              <Col xs={24} sm={12} style={{ marginRight: 0, textAlign: "center", background: "white" }} >
                <Row><span style={{ fontWeight: "bold" }}>Total Vendas</span></Row>
                <Row><span>R$ {this.renderValor(this.state.totalVendas)}</span></Row>
              </Col>
            </Col> */}
          </Col>

          <CondicionalForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <CondicionalPrintModal
            visivel={formPrintA4Visivel}
            venc_idf={this.state.idfCond}
            onCancelarPrintClick={this.onCancelarPrintClick}
          />

          <TutorialCondicionais
            isOpen={this.state.modalOpen}
            onClose={() => this.setState({ modalOpen: false })}
          />
        </div>



        <div style={{ paddingTop: 0 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            rowKey={(registro => registro.venc_idf)}
          >
            <Column
              key="venc_numero"
              dataIndex="venc_numero"
              title={this.renderTitulo("Número")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={80}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="venc_dt_venda"
              dataIndex="venc_dt_venda"
              title={this.renderTitulo("Emissão")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={120}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={200}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="usu_nome"
              dataIndex="usu_nome"
              title={this.renderTitulo("Vendedor")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={100}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="venc_vlr_total"
              dataIndex="venc_vlr_total"
              title={this.renderTitulo("Valor Total")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderValor}
              width={90}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
              render={this.renderAcoes}
              width={120}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/CondicionaisPage.js